// @flow

import "./vendor.js";

import Raven from "raven-js";

const environment = window.ENV_NAME_TRS_ONLINE_IDENTITY_APPLICATION;
const sentryUrl = window.SENTRY_URL_TRS_ONLINE_IDENTITY_APPLICATION;

if (environment && sentryUrl) {
    try {
        Raven.config(sentryUrl, {
            environment
        }).install();
    } catch (e) {
        window.TRS_ONLINE_IDENTITY_APP_ERROR = e;
    }
    window.onunhandledrejection = function(err) {
        Raven.captureException(err.reason);
    };
}

import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";

import { App } from "./app.js";

Raven.context(function() {
    const reRender = Comp => {
        return render(
            <AppContainer>
                <Comp />
            </AppContainer>,
            document.getElementById("root")
        );
    };

    reRender(App);

    if (module && module.hot) {
        module.hot.accept("./app.js", () => reRender(App));
    }
});
